// API + WebSocket endpoint resolution.
// 2026-05-29 EXTRACTED from src/App.jsx (C1 Phase 2e shared-helpers).
// Self-contained IIFEs reading window.location — zero App.jsx coupling.
// API_BASE re-exported from App.jsx for backward compat (14 external importers).

export const API_BASE = (() => {
  const h = window.location.hostname;
  if (h === 'localhost' || h === '127.0.0.1') return 'http://localhost:3001/api';
  return '/api';
})();


export const WS_URL = (() => {
  const h = window.location.hostname;
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  if (h === 'localhost' || h === '127.0.0.1') return 'ws://localhost:3001/ws';
  // Include port if non-standard (important for direct server access without reverse proxy)
  const port = window.location.port;
  const portSuffix = port && port !== '80' && port !== '443' ? `:${port}` : '';
  return `${proto}//${h}${portSuffix}/ws`;
})();
